import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import React from "react";
import { useFormContext } from "react-hook-form";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFLookupWarehouse } from "src/components/Shared/NewForms/NFLookupWarehouse";
import { NFLookupDivision } from "src/components/Shared/NewForms/NFLookupDivision";

export const WriteOffGoodsDetailMain = () => {
  const { t } = useTranslation();
  const { getValues } = useFormContext();
  const { watch } = useFormContext();

  return (
    <>
      <div className={"panel-body tabs-menu-body main-content-body-right"}>
        <Row>
          <Col sm={6}>
            <NFTextInput title={t("Document#")} fieldName={"documentNumber"} disabled />
          </Col>
          <Col sm={6}>
            <NFDateInput title={t("DocumentDate")} fieldName={"documentDate"} required />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <NFLookupCompany fieldName={"companyId"} title={t("Company")} required />
          </Col>
          <Col sm={6}>
            <NFLookupWarehouse
              fieldName={"warehouseId"}
              title={t("Warehouse")}
              // required
              companyId={getValues("companyId")}
              divisionId={getValues("divisionId")}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <NFLookupDivision
              fieldName={"divisionId"}
              title={t("Division")}
              // required
              companyId={watch("companyId")}
              warehouseId={""}
            />
          </Col>
          <Col sm={6}>
            <NFDateInput title={t("CreatedDate")} fieldName={"createdDate"} required disabled={true} />
          </Col>
        </Row>
      </div>
    </>
  );
};
